import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { API } from '../config/apiBase';

// Defaults batem com FEATURE_DEFAULTS no backend.
const DEFAULTS = {
    show_plans: false,
    // Coleta passiva da inteligência. Vem do backend (INTELIGENCIA_COLLECTION_ENABLED e
    // o percentual de rollout); desligada até a resposta chegar.
    intelligence_tracking: false,
    intelligence_tracking_percent: 0,
};

// `carregado` diz se a resposta do backend já chegou (ou falhou). Enquanto for
// false, `features` são só os defaults: quem decide layout pela flag, como o hero
// da Home, precisa esperar, senão desenha o estado "desligado" e troca logo depois.
const FeaturesContext = createContext({ features: DEFAULTS, carregado: true, refresh: () => {} });

export function FeaturesProvider({ children }) {
    const [features, setFeatures] = useState(DEFAULTS);
    const [carregado, setCarregado] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const r = await fetch(`${API}/system/features`, { credentials: 'include' });
            if (r.ok) {
                const d = await r.json();
                // Preview de desenvolvimento da Central: `?preview=central` liga a
                // flag SÓ no navegador de quem está desenvolvendo. O build de
                // produção remove este bloco, e a flag real continua no backend.
                if (process.env.NODE_ENV !== 'production'
                    && typeof window !== 'undefined'
                    && (new URLSearchParams(window.location.search).get('preview') || '').startsWith('central')) {
                    d.promotions_hub = true;
                }
                setFeatures({ ...DEFAULTS, ...d });
            }
        } catch (_) { /* mantem defaults */ }
        setCarregado(true);
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <FeaturesContext.Provider value={{ features, carregado, refresh }}>
            {children}
        </FeaturesContext.Provider>
    );
}

export function useFeatures() {
    return useContext(FeaturesContext);
}

export function useFeaturesCarregadas() {
    return useContext(FeaturesContext).carregado;
}

// Helper conveniente pra components que so leem
export function useFeature(key) {
    const { features } = useFeatures();
    return !!features[key];
}
